import { render } from "./ClientUsersSelector.vue?vue&type=template&id=445b98fe"
import script from "./ClientUsersSelector.vue?vue&type=script&lang=js"
export * from "./ClientUsersSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__